import React, { useState } from 'react';
import { google, outlook, office365, yahoo, ics } from "calendar-link";
import { Link, Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Stack } from "@mui/material";
import Iconify from "../../../components/minimal/iconify/index.jsx";
import { IconButton } from "@mui/material";
import { useLocales } from "../../../locales";
import useResponsive from "../../../hooks/minimal/useResponsive.jsx";
import { display } from '@mui/system';

function addOneHour(dateString) {
    // Parse the date string into a Date object
    const date = new Date(dateString);
    // Add one hour
    date.setHours(date.getHours() + 1);
    // Convert back to ISO string format with 'Z' timezone notation
    return date.toISOString();
}

const AddToCalendar = ({ event }) => {
    let { name, description, start_date, end_date, start_hour, end_hour, location } = event
    const { translate } = useLocales();
    const isMobile = useResponsive('down', 'sm');
    start_hour = start_hour || start_date;
    end_date = end_date || start_date;
    // if end_hour is not provided, set it to start_hour + 1 hour
    end_hour = end_hour || addOneHour(start_hour)
    // concat the day from start_date with the hour and minutes from start_hour
    const start = new Date(start_date);
    start.setHours(new Date(start_hour).getHours(), new Date(start_hour).getMinutes());

    const endDay = new Date(end_date || start_date);
    // end_hour or start_hour + 1 hour
    const end = endDay.setHours(new Date(end_hour).getHours(), new Date(end_hour).getMinutes());

    const googleLink = google({
        title: name,
        description,
        start,
        end,
        location
    });

    const outlookLink = outlook({
        title: name,
        description,
        start,
        end,
        location
    });

    const office365Link = office365({
        title: name,
        description,
        start,
        end,
        location
    });

    const icsLink = ics({
        title: name,
        description,
        start,
        end,
        location
    });

    const [open, setOpen] = useState(false);

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);


    return (
        <>
            <Link onClick={handleOpen} style={{ cursor: 'pointer' }}>
                {translate('event_page.add_to_calendar')}
            </Link>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="dialog-title"
                aria-describedby="dialog-description"
                fullWidth
                maxWidth="xs"
            >
                <DialogTitle sx={{ p: 2 }}>
                    <Stack direction="row" justifyContent="space-between" alignItems="center" >
                        <Typography variant="h5">
                            {translate('event_page.add_to_calendar')}
                        </Typography>
                        <IconButton onClick={handleClose}>
                            <Iconify width="24px" icon="eva:close-outline" />
                        </IconButton>
                    </Stack>
                </DialogTitle>
                <DialogContent>
                    <Stack style={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', justifyContent: 'space-between', alignItems: 'stretch', gap: 2, columnGap: 2, flexWrap: 'wrap' }}>
                        <Button color='info' size='large' variant='outlined' sx={{ textTransform: 'capitalize', minWidth: '48%', mb: 1 }} href={googleLink} target="_blank" rel="noopener noreferrer" startIcon={<Iconify icon="logos:google-calendar" />}>
                            Google Calendar
                        </Button>
                        <Button color='info' size='large' variant='outlined' sx={{ textTransform: 'capitalize', minWidth: '48%', mb: 1 }} href={outlookLink} target="_blank" rel="noopener noreferrer" startIcon={<Iconify icon="vscode-icons:file-type-outlook" />}>
                            Outlook
                        </Button>
                        <Button color='info' size='large' variant='outlined' sx={{ textTransform: 'capitalize', minWidth: '48%', mb: 1 }} href={office365Link} target="_blank" rel="noopener noreferrer" startIcon={<Iconify icon="logos:microsoft-icon" />}>
                            Microsoft 365
                        </Button>
                        <Button color='info' size='large' variant='outlined' sx={{ textTransform: 'capitalize', minWidth: '48%', mb: 1 }} href={icsLink} target="_blank" rel="noopener noreferrer" startIcon={<Iconify icon="mdi:calendar" />}>
                            iCal
                        </Button>
                    </Stack>
                </DialogContent>
            </Dialog >
        </>
    )
}

export default AddToCalendar;
